(function () {
  var KEY = 'bf-day-night';
  var root = document.documentElement;
  function read() { try { return sessionStorage.getItem(KEY) === 'night'; } catch (e) { return false; } }
  function save(night) { try { sessionStorage.setItem(KEY, night ? 'night' : 'day'); } catch (e) {} }
  function apply(night) {
    root.classList.toggle('dn-is-night', night);
    document.querySelectorAll('[data-dn-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', night ? 'true' : 'false');
    });
  }
  function syncFit(scope) {
    (scope || document).querySelectorAll('.dn-night').forEach(function (n) {
      var day = n.parentElement && n.parentElement.querySelector('img:not(.dn-night__img)');
      if (!day) return;
      var cs = getComputedStyle(day);
      n.style.setProperty('--dn-fit', cs.objectFit || 'cover');
      n.style.setProperty('--dn-pos', cs.objectPosition || 'center');
    });
  }
  function placeButtons() {
    document.querySelectorAll('.dn-item').forEach(function (li) {
      var media = li.querySelector('.product__media');
      var btn = li.querySelector(':scope > .dn-btn');
      if (!media || !btn) return;
      var top = media.getBoundingClientRect().top - li.getBoundingClientRect().top;
      var right = li.getBoundingClientRect().right - media.getBoundingClientRect().right;
      li.style.setProperty('--dn-top', Math.max(0, Math.round(top)) + 'px');
      li.style.setProperty('--dn-right', Math.max(0, Math.round(right)) + 'px');
    });
  }
  window.addEventListener('resize', function () { requestAnimationFrame(placeButtons); });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dn-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll('.dn-hint-show').forEach(function (b) { b.classList.remove('dn-hint-show'); });
    var night = !root.classList.contains('dn-is-night');
    save(night);
    apply(night);
  }, true);
  var HINT = 'bf-day-night-hint';
  function showHint() {
    try { if (sessionStorage.getItem(HINT)) return; } catch (e) {}
    var btn = document.querySelector('.dn-btn--bar') || document.querySelector('.dn-item .dn-btn');
    if (!btn) return;
    var fire = function () {
      setTimeout(function () {
        btn.classList.add('dn-hint-show');
        try { sessionStorage.setItem(HINT, '1'); } catch (e) {}
        setTimeout(function () { btn.classList.remove('dn-hint-show'); }, 5000);
      }, 900);
    };
    if (!('IntersectionObserver' in window)) return fire();
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); fire(); }
    }, { threshold: 1 });
    io.observe(btn);
  }
  function init() { syncFit(); placeButtons(); apply(read()); window.addEventListener('load', placeButtons); showHint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // re-sync after section re-renders (facets, variant change)
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; syncFit(); placeButtons(); apply(root.classList.contains('dn-is-night')); });
  }).observe(document.body || root, { childList: true, subtree: true });
})();
